import { useEffect, useRef } from 'react';
import { getBookingCostBreakdown } from '../../../redux/actions/bookingParAm';
import { BOOKING_FORM_NO_TIME } from './bookingFormHelpers';

function isUnsetBookingInstant(value) {
  return value == null || value === '' || value === BOOKING_FORM_NO_TIME || value === '-1';
}

export function useBookingCostBreakdownFetcher({
  active,
  requirePayment,
  buildingId,
  amenityId,
  startDateIso,
  endDateIso,
  dispatch,
  onFail
}) {
  const lastFetchKeyRef = useRef(null);

  useEffect(() => {
    if (!active || !requirePayment) {
      lastFetchKeyRef.current = null;
      return;
    }

    const buildingIdInt = parseInt(buildingId, 10);
    const amenityIdInt = parseInt(amenityId, 10);

    if (
      !Number.isFinite(buildingIdInt) ||
      buildingIdInt <= 0 ||
      !Number.isFinite(amenityIdInt) ||
      amenityIdInt <= 0 ||
      isUnsetBookingInstant(startDateIso) ||
      isUnsetBookingInstant(endDateIso)
    ) {
      lastFetchKeyRef.current = null;
      return;
    }

    const fetchKey = `${buildingIdInt}-${amenityIdInt}-${startDateIso}-${endDateIso}`;
    if (lastFetchKeyRef.current === fetchKey) return;
    lastFetchKeyRef.current = fetchKey;

    dispatch(
      getBookingCostBreakdown({
        params: {
          building: buildingIdInt,
          amenity_id: amenityIdInt,
          start_date: startDateIso,
          end_date: endDateIso
        },
        fail: onFail
      })
    );
  }, [
    active,
    requirePayment,
    buildingId,
    amenityId,
    startDateIso,
    endDateIso,
    dispatch,
    onFail
  ]);

  return { lastFetchKeyRef };
}
